module.exports = __webpack_public_path__ + "img/rules.12befa2e.svg";